import React from 'react';
import { ResultValue } from '../../Simple';
import { formatStringWithPrecision, stringNumberToFlag, formatDateString, formatStringAsCurrency } from '../../../Utils/stringUtils';
import { API_DATE_STRING_FORMAT, DATE_STRING_FORMAT } from '../../../Constants/stringFormats';
import { ESRD, HH, IPPS, LTCH, OPPS, PFS, PSYCH, REHAB, SNF } from '../../../Constants/modelTypes';

export default function FactorAndAdjustments(props) {
    if (props.model === IPPS) {
        return (<>
            <h4>PPS Factors & Adjustments</h4>
            <ResultValue label="Wage Index" value={formatStringWithPrecision(props.result.wageIndex, 4)} />
            <ResultValue label="DRG Weight" value={formatStringWithPrecision(props.result.drgWeight, 4)} />
            <ResultValue label="Transfer Adj. Factor" value={formatStringWithPrecision(props.result.transferFactor, 4)} />
            <ResultValue label="EHR Reduction" value={stringNumberToFlag(props.result.ehrReductionInd)} />
            <ResultValue label="HAC Reduction" value={props.result.hacReductionInd} />
            <ResultValue label="COVID-19 PHE Admit" value={stringNumberToFlag(props.result.coviD19PHEPeriodAdmit)} />
            <ResultValue label="Operating Cost-to-Charge Ratio" value={formatStringWithPrecision(props.result.opCCR, 4)} />
            <ResultValue label="Capital Cost-to-Charge Ratio" value={formatStringWithPrecision(props.result.capCCR, 4)} />
        </>);
    }

    if (props.model === PSYCH) {
        return (<>
            <h4>PPS Factors & Adjustments</h4>
            <ResultValue label="Wage Index" value={formatStringWithPrecision(props.result.wageIndex, 4)} />
            <ResultValue label="DRG Weight" value={formatStringWithPrecision(props.result.drgWeight, 4)} />
            <ResultValue label="CBSA" value={props.result.cbsa} />
            <ResultValue label="EHR Reduction" value={stringNumberToFlag(props.result.ehrReductionInd)} />
            <ResultValue label="Comorbidity Adjustment" value={formatStringWithPrecision(props.result.comorbAdj, 4)} />
            <ResultValue label="Age Adjustment" value={formatStringWithPrecision(props.result.ageAdj, 4)} />
            <ResultValue label="Rural Adjustment" value={formatStringWithPrecision(props.result.ruralAdj, 4)} />
            <ResultValue label="ECT Units" value={props.result.ectUnits} />
            <ResultValue label="Provider has Emergency Department" value={props.result.emergencyDepartment} />
            <ResultValue label="Cost-to-Charge Ratio" value={formatStringWithPrecision(props.result.ccr, 4)} />
        </>);
    }

    if (props.model === REHAB) {
        return (<>
            <h4>PPS Factors & Adjustments</h4>
            <ResultValue label="Wage Index" value={formatStringWithPrecision(props.result.wageIndex, 4)} />
            <ResultValue label="Rural Adjustment" value={formatStringWithPrecision(props.result.ruralAdj, 4)} />
            <ResultValue label="CBSA" value={props.result.cbsa} />
            <ResultValue label="CMG Weight" value={formatStringWithPrecision(props.result.cmgWeight, 4)} />
            <ResultValue label="CMG Average LOS" value={props.result.cmgAverageLOS} />
            <ResultValue label="Transfer" value={props.result.rehabTransfer} />
            <ResultValue label="Cost-to-Charge Ratio" value={formatStringWithPrecision(props.result.ccr, 3)} />
        </>);
    }

    if (props.model === SNF) {
        return (<>
            <h4>PPS Factors & Adjustments</h4>
            <ResultValue label="Labor Related Share" value={formatStringWithPrecision(props.result.laborRelatedShare, 4)} />
            <ResultValue label="Wage Index" value={formatStringWithPrecision(props.result.wageIndex, 4)} />
            <ResultValue label="AIDS Indicator" value={stringNumberToFlag(props.result.aidsIndicator)} />
            <ResultValue label="VBP Adjustment" value={formatStringWithPrecision(props.result.vbpAdj, 4)} />
            <ResultValue label="QRP Adjustment" value={formatStringWithPrecision(props.result.qrpAdj, 4)} />
            <ResultValue label="Total QRP Impact" value={formatStringAsCurrency(props.result.totalQRPImpact)} />
        </>);
    }

    if (props.model === LTCH) {
        return (<>
            <h4>PPS Factors & Adjustments</h4>
            <ResultValue label="Wage Index" value={formatStringWithPrecision(props.result.wageIndex, 4)} />
            <ResultValue label="CBSA" value={props.result.cbsa} />
            <ResultValue label="DRG Weight" value={formatStringWithPrecision(props.result.drgWeight, 4)} />
            <ResultValue label="EHR Reduction" value={stringNumberToFlag(props.result.ehrReductionInd)} />
            <ResultValue label="Site Neutral Payment Applies" value={stringNumberToFlag(props.result.siteNeutral)} />
            <ResultValue label="DPP Adjustment Override" value={props.result.dppAdjOverride} />
            <ResultValue label="COVID-19 PHE Admit" value={stringNumberToFlag(props.result.coviD19PHEPeriodAdmit)} />
            <ResultValue label="Cost-to-Charge Ratio" value={formatStringWithPrecision(props.result.costToChargeRatio, 4)} />
        </>);
    }

    if (props.model === OPPS) {
        return (<>
            <h4>Factors & Adjustments</h4>
            <ResultValue label="Wage Index" value={formatStringWithPrecision(props.result.wageIndexFactor, 4)} />
            <ResultValue label="GPCI Work" value={formatStringWithPrecision(props.result.gpciWork, 4)} />
            <ResultValue label="GPCI Practice" value={formatStringWithPrecision(props.result.gpciPractice, 4)} />
            <ResultValue label="GPCI Malpractice" value={formatStringWithPrecision(props.result.gpciMalpractice, 4)} />
            <ResultValue label="Cost-to-Charge Ratio (CCR)" value={formatStringWithPrecision(props.result.ccr, 4)} />
            <ResultValue label="CCR Effective Date" value={formatDateString(props.result.ccrEffectiveDate, API_DATE_STRING_FORMAT, DATE_STRING_FORMAT)} />
            <ResultValue label="Outlier Amount" value={formatStringAsCurrency(props.result.outlierAmount)} />
        </>);
    }

    if (props.model === PFS) {
        return (<>
            <h4>Factors & Adjustments</h4>
            <ResultValue label="GPCI Work" value={formatStringWithPrecision(props.result.gpciWork, 4)} />
            <ResultValue label="GPCI Practice" value={formatStringWithPrecision(props.result.gpciPractice, 4)} />
            <ResultValue label="GPCI Malpractice" value={formatStringWithPrecision(props.result.gpciMalpractice, 4)} />
            <ResultValue label="Specialty Adjustment" value={formatStringWithPrecision(props.result.specialtyAdjustment, 4)} />
        </>);
    }

    if (props.model === ESRD) {
        return (<>
            <h4>Factors & Adjustments</h4>
            <ResultValue label="Wage Index" value={formatStringWithPrecision(props.result.wageIndexFactor, 4)} />
            <ResultValue label="Modality Multiplier" value={formatStringWithPrecision(props.result.modalityMultiplier, 4)} />
            <ResultValue label="Low Volume Adjustment" value={formatStringWithPrecision(props.result.lowVolumeAdjustment+1, 4)} />
            <ResultValue label="QIP Adjustment" value={formatStringWithPrecision(props.result.qipAdjustment+1, 4)} />
            <ResultValue label="Non-Contiguous Areas Payment Adjustment" value={formatStringWithPrecision(props.result.napaFactor+1, 4)} />
            <ResultValue label="Rural Adjustment" value={formatStringWithPrecision(props.result.ruralAdjustment+1, 4)} />
            <ResultValue label="ETC Model - Home Dialysis Payment Adjustment" value={formatStringWithPrecision(props.result.hdpaAdjustment+1, 4)} />
            <ResultValue label="ETC Model - Performance Payment Adjustment" value={formatStringWithPrecision(props.result.ppaAdjustment+1, 4)} />
            <ResultValue label="BSA Adjustment" value={formatStringWithPrecision(props.result.bsaAdjustment+1, 4)} />
            <ResultValue label="BMI Adjustment" value={formatStringWithPrecision(props.result.bmiAdjustment+1, 4)} />
            <ResultValue label="Age Adjustment" value={formatStringWithPrecision(props.result.ageAdjustment+1, 4)} />
            <ResultValue label="Comorbidity Adjustment" value={formatStringWithPrecision(props.result.comorbidityAdjustment+1, 4)} />
            <ResultValue label="Dialysis Onset Adjustment" value={formatStringWithPrecision(props.result.dialysisOnsetAdjustment+1, 4)} />
            <ResultValue label="TPEAPA Adjustment" value={formatStringWithPrecision(props.result.tpeapaAdjustment+1, 4)} />
            <ResultValue label="Post-TDAPA Add-On Payment Adjustment" value={formatStringAsCurrency(props.result.postTDAPAAdjustment)} />
        </>);
    }

    if (props.model === HH) {
        return (<>
            <h4>PPS Factors and Adjustments</h4>
            <ResultValue label="HIPPS / HHRG / PDGM Code" value={props.calendarYear >= 2020 ? props.result.hipps : props.result.hhrg} />
            <ResultValue label="HIPPS / HHRG / PDGM Weight" value={props.calendarYear >= 2020 ? formatStringWithPrecision(props.result.hippsWeight, 4) : formatStringWithPrecision(props.result.hhrgWeight, 4)} />
            {props.calendarYear >= 2020 && <ResultValue label="LUPA Visit Threshold" value={props.result.lupaThreshold} />}
            <ResultValue label="Wage Index" value={formatStringWithPrecision(props.result.wageIndex, 4)} />
            <ResultValue label="Quality Data" value={stringNumberToFlag(props.result.qualityData)} />
            <ResultValue label="VBP Adjustment" value={formatStringWithPrecision(props.result.vbpAdj, 2)} />
        </>);
    }

    console.warn('Model unknown:', props.model);
    return null;

}